export const INSIGHT_SERVICE_URL = process.env.REACT_APP_INSIGHT_SERVICE_URL;
